// Distinct `class.ring` values for a show's class list, in first-seen order.
// score-api has no ring-listing route (docs/score/announcer.md) — ring is FVD
// free text, so the class list is the only source of what rings exist today.
// Shared by InitialSetup (initial ring picker, PIN-gated) and OrderOfGo (#926
// ring pill switcher, ungated) so both stay scoped to the same show's rings.
export function ringsFor(classList) {
  const seen = [];
  for (const c of classList ?? []) {
    if (c.ring && !seen.includes(c.ring)) seen.push(c.ring);
  }
  return seen;
}
